import { render } from "./OrderProgress.vue?vue&type=template&id=2ae98ad8"
import script from "./OrderProgress.vue?vue&type=script&lang=js"
export * from "./OrderProgress.vue?vue&type=script&lang=js"

import "./OrderProgress.vue?vue&type=style&index=0&id=2ae98ad8&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__